<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <span class="display-flex-row">
      <label class="margin-bottom-small">
        {{ $t(`aLogoEdition.${entity}.label`) }}
      </label>
      <span
        class="a-tooltip-secondary a-tooltip-right margin-left-xsmall font-size-small text-color-black-35"
        :data-tooltip-text="$t(`aLogoEdition.${entity}.tooltip`)"
      >
        <i class="fas fa-info-circle"></i>
      </span>
    </span>
    <span class="a-logo-edition">
      <span :class="`a-logo-edition-img-${clase}`">
        <img
          v-if="logoImg.length"
          key="logoImgTag"
          id="logoImgTag"
          :src="logoImg"
        >
        <img
          v-else
          key="defaultImg"
          id="logoImgTag"
          src="@/assets/img/logo-edition-billing.png"
        >
      </span>
      <a
        v-if="!buttonSecondary"
        :class="`font-size-small text-link-hover-${clase}`"
        href="#"
        @click.prevent="changeLogoImage('inputImagen')"
      >
        {{ $t('aLogoEdition.changeLogo') }}
      </a>
    </span>
    <small
      v-if="buttonSecondary"
      class="margin-top-small display-flex-column width-200-px"
    >
      <button
        v-if="!logoImg.length"
        :class="`a-button-logo-edition ${buttonSecondary.upload.class}`"
        :data-tooltip-text="buttonSecondary.upload.tooltip"
        :type="buttonSecondary.upload.type"
        @click.prevent="changeLogoImage('inputImagen')"
      >
        <i
          v-if="buttonSecondary.upload.icon.length"
          :class="buttonSecondary.upload.text.length
            ? `${buttonSecondary.upload.icon} margin-right-xsmall`
            : buttonSecondary.upload.icon"
        >
        </i>
        <span v-show="buttonSecondary.upload.text.length">{{ buttonSecondary.upload.text }}</span>
      </button>
      <button
        v-if="logoImg.length"
        :class="`a-button-logo-edition ${buttonSecondary.modify.class}`"
        :data-tooltip-text="buttonSecondary.modify.tooltip"
        :type="buttonSecondary.modify.type"
        @click.prevent="changeLogoImage('inputImagen')"
      >
        <i
          v-if="buttonSecondary.modify.icon.length"
          :class="buttonSecondary.modify.text.length
            ? `${buttonSecondary.modify.icon} margin-right-xsmall`
            : buttonSecondary.modify.icon"
        >
        </i>
        <span v-show="buttonSecondary.modify.text.length">{{ buttonSecondary.modify.text }}</span>
      </button>
      <button
        v-if="logoImg.length"
        :class="`a-button-logo-edition ${buttonSecondary.delete.class}`"
        :data-tooltip-text="buttonSecondary.delete.tooltip"
        :type="buttonSecondary.delete.type"
        @click.prevent="deleteLogoImage('inputImagen')"
      >
        <i
          v-if="buttonSecondary.delete.icon.length"
          :class="buttonSecondary.delete.text.length
            ? `${buttonSecondary.delete.icon} margin-right-xsmall`
            : buttonSecondary.delete.icon"
        >
        </i>
        <span v-show="buttonSecondary.delete.text.length">{{ buttonSecondary.delete.text }}</span>
      </button>
    </small>
    <input
      v-show="false"
      name="file"
      id="inputImagen"
      ref="file"
      type="file"
      value=""
      @change="previewLogoImage"
    >
    <small class="display-flex-column font-weight-light margin-top-medium">
      <span><i>{{ $t(`aLogoEdition.${entity}.messages.dimensions`) }}</i></span>
      <span><i>{{ $t(`aLogoEdition.${entity}.messages.extensions`) }}</i></span>
    </small>
    <small
      v-if="!isFileExtensionValid"
      class="text-color-danger"
    >
      {{ messageErrorFileExtension }}
    </small>
    <small
      v-if="!isFileSizeValid"
      class="text-color-danger"
    >
      {{ messageErrorFileSize }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomLogoEdition',

  props: {
    buttonSecondary: Object,

    clase: String,

    entity: String,

    logoImg: {
      type: String,
      default: ''
    },
    tooltip: String,
    wrapperClass: String
  },

  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true,
      inputError: false
    }
  },

  computed: {
    messageErrorFileExtension () {
      return this.$t('aLogoEdition.validation.file.extension')
    },

    messageErrorFileSize () {
      return this.$t('aLogoEdition.validation.file.size')
    }
  },

  methods: {
    changeLogoImage (inputId) {
      document.getElementById(inputId).click()
    },

    deleteLogoImage (inputId) {
      document.getElementById(inputId).value = ''
      document.getElementById('logoImgTag').src = ''
      this.$emit('changeLogoImage', '')
    },

    previewLogoImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.clase === 'academy'
        ? this.$files.allowedFileExtension(input.files[0].name, 'image')
        : input.files[0].name.split('.').pop() === 'png'
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById('logoImgTag').src = e.target.result
          this.$emit('changeLogoImage', e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>
